module.exports = __webpack_public_path__ + "img/Speaker=Helen Huang.b133d5a6.png";